<br />
<br />
<mat-sidenav-container>
  <mat-sidenav id="sidenav" #sidenav mode="side" position="end">
    <visor-ine
      *ngIf="empleado_asignado.idEmpleado"
      #visorIne
      [idEmpleado]="empleado_asignado.idEmpleado"
    ></visor-ine>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="inicio">
      <div class="columnas_1">
        <div class="columnas_layout_3">
          <div class="example-button-row">
            <button
              mat-mini-fab
              color="accent"
              matTooltip="Regresas a la ver los registros y pendientes del empleado en curso"
              (click)="clickGoBack($event)"
            >
              <mat-icon style="transform: rotate(180deg)"
                >forward icon</mat-icon
              >
            </button>
          </div>

          <div class="columnas_layout">
            <p class="titulo">
              DETALLE DE ASIGNACIÓN
              <button
                mat-mini-fab
                color="primary"
                matTooltip="Aquí puedes generar la responsiva, la carta responsiva y los pagares de forma general o de forma individual, igualemnte se puede subir los formatos de manera individual o general."
                (click)="clickInformacion($event)"
              >
                <mat-icon>info</mat-icon>
              </button>
            </p>
          </div>
        </div>
        <button
          mat-stroked-button
          color="warn"
          (click)="reload()"
          matTooltip="RECARGAR PAGINA"
          hidden
        >
          <mat-icon>autorenew</mat-icon>
        </button>
        <p class="subtitulo" (click)="mostrarRPGeneral()">
          <br />
          DATOS GENERALES
        </p>

        <div class="columnas_3">
          <!--PRIMERA FILA-->
          <div>
            <mat-label class="subtitulo"> FECHA DE ASIGNACIÓN: </mat-label>
            <mat-label class="texto">
              {{ registroAsignacionEquipo.fecha_asignacion_cadena }}
            </mat-label>
          </div>

          <div>
            <mat-label class="subtitulo"> NOMBRE DEL EMPLEADO: </mat-label>
            <mat-label class="texto">
              {{ registroAsignacionEquipo.nombre_empleado_asignado }}
            </mat-label>
          </div>

          <div>
            <mat-label class="subtitulo"> ESTADO ACTUAL: </mat-label>
            <mat-label class="texto">
              {{ registroAsignacionEquipo.status_registro }}
            </mat-label>
          </div>

          <!--SEGUNDA FILA-->
          <div>
            <mat-label class="subtitulo"> ÚLTIMA MODIFICACIÓN: </mat-label>
            <mat-label class="texto">
              {{ registroAsignacionEquipo.fecha_modificacion_cadena }}
            </mat-label>
          </div>

          <div>
            <mat-label class="subtitulo">
              RESPONSABLE DE LA ASIGNACIÓN:
            </mat-label>
            <mat-label class="texto">
              {{ registroAsignacionEquipo.nombre_empleado_registra }}
            </mat-label>
          </div>

          <div>
            <mat-label class="subtitulo">OBSERVACIONES GENERALES: </mat-label>
            <mat-label class="texto">
              {{ registroAsignacionEquipo.observaciones }}</mat-label
            >
          </div>
        </div>

        <br /><br />

        <mat-checkbox
          [(ngModel)]="checkbandera"
          [disabled]="loadingColaboradores"
          (change)="onCheckboxChange($event)"
          >Añadir Responsiva</mat-checkbox
        >
        <mat-progress-bar
          *ngIf="loadingColaboradores"
          mode="indeterminate"
        ></mat-progress-bar>
        <h4
          *ngIf="loadingColaboradores"
          style="
            background-color: antiquewhite;
            text-align: center;
            border-radius: 10px;
          "
        >
          <strong>Cargando información espere un momento...</strong>
        </h4>

        <div *ngIf="bandera">
          <div class="columnas_1">
            <mat-label class="subtitulo_v2"
              >Responsable de entrega<mat-label class="advertencia"
                >*</mat-label
              >
              <mat-icon
                matTooltip="Nombre de la persona responsable de entregar el equipo"
                class="white-icon"
                >help</mat-icon
              >
            </mat-label>
            <mat-form-field appearance="fill">
              <mat-select
                [formControl]="select_gerente"
                #singleSelect1
                (selectionChange)="
                  clickSelectResponsableExtiendeResponsiva($event)
                "
              >
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="input_gerente"
                    oninput="
                      this.value
                        ? (this.value = this.value.toUpperCase())
                        : null
                    "
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option
                  *ngFor="let option of listaFiltradaColaboradores | async"
                  [value]="option"
                >
                  {{ option.nomb_compl }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="columnas_1">
            <mat-label class="subtitulo_v2"
              >Apoderado Legal<mat-label class="advertencia">*</mat-label>
              <mat-icon
                matTooltip="Nombre del apoderado legal"
                class="white-icon"
                >help</mat-icon
              >
            </mat-label>
            <mat-form-field appearance="fill">
              <mat-select
                [formControl]="select_apoderado"
                #singleSelect2
                (selectionChange)="
                  clickSelectResponsableExtiendeResponsivaApoderado($event)
                "
              >
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="input_apoderado"
                    oninput="
                      this.value
                        ? (this.value = this.value.toUpperCase())
                        : null
                    "
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option
                  *ngFor="let option of listaFiltradaApoderado | async"
                  [value]="option"
                >
                  {{ option.nomb_compl }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <mat-card
            class="result"
            *ngIf="
              showRPGeneral == 3 ||
              showRPGeneral == 6 ||
              showRPGeneral == 8 ||
              showRPGeneral == 10 ||
              showRPGeneral == 12 ||
              showRPGeneral == 15 ||
              showRPGeneral == 20
            "
          >
            <mat-card-content>
              <section
                class="example-section"
                *ngIf="this.dataSource.data.length == 1"
              >
                <mat-checkbox
                  class="example-margin"
                  [(ngModel)]="flagResponsivaGeneral"
                >
                  Generar responsiva general
                </mat-checkbox>
              </section>
              <hr />

              <section
                class="example-section"
                *ngIf="this.dataSource.data.length > 1"
              >
                <mat-checkbox
                  class="example-margin"
                  [(ngModel)]="flagResponsivaIndivual"
                >
                  Generar responsiva individual
                </mat-checkbox>
              </section>
            </mat-card-content>
          </mat-card>
          <div class="columnas_2">
            <div class="columnas_1" *ngIf="habiilitarFormularioComputadora()">
              <mat-label class="subtitulo">
                RESPONSIVA DE EQUIPO
                <button
                  mat-mini-fab
                  color="primary"
                  (click)="descargarResponsivaGeneral()"
                  [disabled]="!habilitarBtnDescargarResponsiva()"
                  matTooltip="Aquí puedes generar la responsiva de forma general."
                >
                  <mat-icon>download</mat-icon>
                </button>
                <mat-label class="advertencia"></mat-label>
              </mat-label>

              <div class="columnas_2">
                <mat-form-field appearance="fill" floatLabel="always">
                  <mat-label>DIRECCION MAC </mat-label>
                  <input
                    matInput
                    [(ngModel)]="this.dataSource.data[0].direccion_mac"
                    placeholder="00.00.00.00.00.00"
                    minlength="17"
                    maxlength="17"
                  />
                </mat-form-field>

                <mat-form-field appearance="fill" floatLabel="always">
                  <mat-label>DIRECCION IP </mat-label>
                  <input
                    matInput
                    [(ngModel)]="this.dataSource.data[0].direccion_ip"
                    placeholder="000.000.000.000"
                    minlength="12"
                    maxlength="15"
                  />
                </mat-form-field>

                <mat-form-field appearance="fill" floatLabel="always">
                  <mat-label> OFFICE INSTALADO </mat-label>
                  <input
                    matInput
                    [(ngModel)]="this.dataSource.data[0].version_office"
                  />
                </mat-form-field>

                <mat-form-field appearance="fill" floatLabel="always">
                  <mat-label> NUM. SERIE DE LICENCIA OFFICE</mat-label>
                  <input
                    matInput
                    [(ngModel)]="this.dataSource.data[0].licencia_office"
                  />
                </mat-form-field>

                <mat-form-field appearance="fill" floatLabel="always">
                  <mat-label>OTROS PROGRAMAS INSTALADOS </mat-label>
                  <input
                    matInput
                    [(ngModel)]="this.dataSource.data[0].programas_instalados"
                  />
                </mat-form-field>
              </div>
            </div>

            <div
              class="columnas_1"
              *ngIf="habiilitarFormularioEquipoPortatil()"
            >
              <div class="columnas_2">
                <mat-label class="subtitulo">
                  CARTA RESPONSIVA
                  <button
                    mat-mini-fab
                    color="primary"
                    (click)="descargarCartaResposiva()"
                    [disabled]="!habilitarBtnDescargarCartaYAnexo()"
                    matTooltip="Aquí puedes generar la carta responsiva."
                  >
                    <mat-icon>download</mat-icon>
                  </button>
                  <mat-label class="advertencia"></mat-label>
                </mat-label>

                <mat-label class="subtitulo">
                  ANEXO
                  <button
                    mat-mini-fab
                    color="primary"
                    (click)="descargarAnexoResponsiva()"
                    [disabled]="!habilitarBtnDescargarCartaYAnexo()"
                    matTooltip="Aquí puedes generar el anexo de carta responsiva."
                  >
                    <mat-icon>download</mat-icon>
                  </button>
                  <mat-label class="advertencia"></mat-label>
                </mat-label>
              </div>

              <mat-form-field
                *ngIf="flagNSerieCargador"
                appearance="fill"
                floatLabel="always"
              >
                <mat-label>N° DE SERIE CARGADOR </mat-label>
                <input
                  required
                  matInput
                  [(ngModel)]="this.dataSource.data[0].numero_serie_cargador"
                  oninput="this.value = this.value.toUpperCase()"
                />
              </mat-form-field>

              <mat-form-field appearance="fill" floatLabel="always">
                <mat-label>FOLIO INE</mat-label>
                <input
                  matInput
                  [(ngModel)]="empleado_asignado.folioIne"
                  oninput="this.value = this.value.toUpperCase()"
                />
              </mat-form-field>
              <mat-form-field appearance="fill" floatLabel="always">
                <mat-label>DOMICILIO DEL EMPLEADO</mat-label>
                <input
                  matInput
                  [(ngModel)]="this.dataSource.data[0].direccion_colaborador"
                  oninput="this.value = this.value.toUpperCase()"
                />
              </mat-form-field>

              <mat-form-field appearance="fill" floatLabel="always">
                <mat-label>PRECIO</mat-label>
                <input
                  matInput
                  type="number"
                  [(ngModel)]="this.dataSource.data[0].precio"
                  placeholder="00 0000"
                  min="0"
                  max="99999"
                  maxlength="5"
                  oninput="
                    if (this.value.length > this.maxLength)
                      this.value = this.value.slice(0, this.maxLength);
                  "
                />
                <span matPrefix>$&nbsp;</span>
                <span matSuffix>.00 pesos</span>
              </mat-form-field>
            </div>
          </div>

          <div class="example-button-row">
            <button
              mat-raised-button
              color="primary"
              (click)="clickActualizarDatosResponsiva($event)"
              matTooltip="Al dar click guardas la información ingresada para la resonsiva de equipo."
            >
              Guardar<mat-icon>save</mat-icon>
            </button>
          </div>
        </div>
        <div>
          <!--TABLA CON TODOS LOS DETALLES DE LA ASIGNACIÓN-->
          <button
            mat-raised-button
            color="accent"
            matTooltip="Subir responsiva de toda la asignación"
            (click)="clickSubirResponsivaComputadora($event)"
            *ngIf="
              mostrarBtnSubirResponsivaComputadoraYCancelarTodaLaAsignacion()
            "
          >
            <mat-icon>unarchive</mat-icon>
          </button>
          <button
            mat-raised-button
            color="primary"
            matTooltip="Agregar un equipo de remplazo"
            (click)="clickAddEquipo($event)"
            *ngIf="mostrarBtnAgregarEquipo()"
          >
            <mat-icon>add </mat-icon>
          </button>
          <button
            mat-raised-button
            color="warn"
            matTooltip="Cancelar toda la asignación"
            (click)="clickCancelarTodoElRegistro($event)"
            *ngIf="
              mostrarBtnSubirResponsivaComputadoraYCancelarTodaLaAsignacion()
            "
          >
            <mat-icon>cancel </mat-icon>
          </button>
          <button
            mat-raised-button
            color="primary"
            matTooltip="Al dar click aseguras que ya no hay pendientes de repsonsiva o equipo."
            (click)="clickBtnTerminarAsignacion($event)"
            *ngIf="mostrarBtnTerminarAsignacion()"
            style="margin-right: 0.5rem"
          >
            Finalizar asignación <mat-icon>check_circle</mat-icon>
          </button>
          <button
            mat-raised-button
            color="primary"
            matTooltip="Al dar click aseguras que ya no hay pendientes de repsonsiva."
            (click)="clickBtnTerminarCancelacion($event)"
            *ngIf="mostrarBtnTerminarCancelacion()"
          >
            Finalizar cancelación<mat-icon>check_circle</mat-icon>
          </button>

          <button
            [disabled]="!empleado_asignado.idEmpleado || !visorIne?.archivo"
            mat-raised-button
            color="primary"
            matTooltip="Ver INE"
            (click)="sidenav.toggle()"
          >
            <mat-icon>credit_card</mat-icon> Ver identificación
          </button>

          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <ng-container matColumnDef="botones">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <button
                  mat-mini-fab
                  color="accent"
                  matTooltip="Subir responsiva"
                  (click)="clickSubirResponsiva(element.id_detalle_asignacion)"
                >
                  <mat-icon>unarchive </mat-icon>
                </button>
                <button
                  mat-mini-fab
                  color="primary"
                  matTooltip="ver responsiva"
                  (click)="clickVerResponsiva(element)"
                  *ngIf="element.archivo != undefined"
                >
                  <mat-icon>visibility</mat-icon>
                </button>
                <button
                  mat-mini-fab
                  style="background-color: #3085d6"
                  matTooltip="Descargar responsiva"
                  (click)="clickDescargarResponsiva(element)"
                  *ngIf="element.archivo != undefined"
                >
                  <mat-icon>download</mat-icon>
                </button>
                <!--button mat-mini-fab [disabled]="true" *ngIf="!element.responsiva"><mat-icon>download</mat-icon></!--button-->
                <button
                  mat-mini-fab
                  color="warn"
                  matTooltip="Cancelar asignación de este equipo"
                  (click)="
                    clickCancelarDetalleDeRegistro(
                      element.equipo_id,
                      element.equipo.tabla,
                      element
                    )
                  "
                  [disabled]="element.bandera"
                >
                  <mat-icon>cancel </mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="nombre del equipo">
              <th mat-header-cell *matHeaderCellDef>NOMBRE DEL EQUIPO</th>
              <td mat-cell *matCellDef="let element">
                {{ element.nombre_equipo }}
              </td>
            </ng-container>

            <ng-container matColumnDef="tipo de equipo">
              <th mat-header-cell *matHeaderCellDef>TIPO DE EQUIPO</th>
              <td mat-cell *matCellDef="let element">
                {{ element.tipo_activo }}
              </td>
            </ng-container>

            <ng-container matColumnDef="estatus">
              <th mat-header-cell *matHeaderCellDef>ESTATUS DE ASIGNACIÓN</th>
              <td mat-cell *matCellDef="let element">
                {{ element.status_detalle }}
              </td>
            </ng-container>

            <ng-container matColumnDef="observavciones">
              <th mat-header-cell *matHeaderCellDef>
                OBSERVACIONES DEL EQUIPO
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.observ_equipo }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="encabezados"></tr>
            <tr mat-row *matRowDef="let row; columns: encabezados"></tr>
          </table>
          <mat-paginator
            #paginator
            class="mat-elevation-z8"
            [pageSize]="10"
            showFirstLastButtons
          ></mat-paginator>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
